import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DateFormatEnum } from '@enums/date-format.enum';
import { GenderEnum } from '@enums/gender.enum';
import { ExtrasInfo, MappedPassengerDetails, Passenger } from '@shared/services/extras/_interfaces_/extras-info.interface';

@Component({
  selector: 'app-passengers-total',
  templateUrl: './passengers-total.component.html',
  styleUrls: ['./passengers-total.component.scss'],
})
export class PassengersTotalComponent implements OnChanges {
  @Input() flightDetails: ExtrasInfo;
  @Input() culture: string;
  public totalPrice: string;
  public passengerExtrasSummary: Array<MappedPassengerDetails> = [];
  ddMMyyyy: string = DateFormatEnum.ddMMyyyy;
  genderEnum: typeof GenderEnum = GenderEnum;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.flightDetails && this.flightDetails) {
      this.totalPrice = this.flightDetails?.priceInfo?.displayTotalPrice;
      this.flightDetails?.passengers.map(
        (passenger: Passenger, index: number) =>
          (this.passengerExtrasSummary = [
            ...this.passengerExtrasSummary,
            {
              name: `${passenger?.passengerDetails?.firstName} ${passenger?.passengerDetails?.lastName}`,
              gender: passenger?.passengerDetails?.gender,
              dateOfBirth: passenger?.passengerDetails?.dateOfBirth,
              displayPassengerPrice: this.flightDetails?.priceInfo?.pricePerPassenger[index]?.selectedExtrasPrice?.totalDisplayPrice,
              passengerType: passenger?.passengerDetails?.passengerType,
            },
          ])
      );
    }
  }
}
